export default {
  getHealthReport(data) {
    return this.http('Bingo', 'get', '/api/v1/health/analyses', data);
  },
  getList(params) {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/product_recommendations',
      params
    );
  },
  getWatchlist({ qs = {} }) {
    return this.http(
      'GENE_BIND',
      'get',
      '/api/v1/bar_code_result_follows',
      qs
    ).then(res => res);
  },
  followOneReport(params) {
    return this.http(
      'GENE_BIND',
      'POST',
      '/api/v1/bar_code_result_follows/update',
      params
    );
  },
  checkFollowingStatus(qs) {
    return this.http(
      'GENE_BIND',
      'GET',
      `/api/v1/bar_code_result_follows/check?bar_code_result_id=${qs.bar_code_result_id}&bar_code=${qs.bar_code}`
    );
  },

  fallback(params) {
    return this.http(
      'SEAFARER',
      'POST',
      '/api/v1/user_nps_survey',
      params
    );
  },

  getFallbackRecord() {
    return this.http('SEAFARER', 'GET', '/api/v1/user_nps_survey');
  },

  getNps() {
    return this.http('SEAFARER', 'GET', '/api/v1/nps_survey');
  },

  getSampleReports() {
    return this.http('GENE_BIND', 'GET', '/api/v1/sample_reports');
  }
};
